import _ from 'lodash';
import moment from 'moment';


export class UserPreferences {
    constructor(options = {}) {
        const o = _.cloneDeep(options || {});

        this.tvDashboardIDs = o.tvDashboardIDs || [];
        this.tvDashboardRotationInterval = o.tvDashboardRotationInterval || 30000;
        this.lastUpdated = o.lastUpdated || this.getTimestamp();
    }

    clone() {
        return new UserPreferences(this);
    }

    static deserialize(options = {}) {
        const result = new UserPreferences(options);

        for (const prop in result) {
            if (!result.hasOwnProperty(prop)) continue;

            let value = result[prop];

            // Serialize arrays to CSV so we can store them in the DB
            if (typeof value === 'string') {
                if ((value.startsWith('[') && value.endsWith(']'))
                    || (value.startsWith('{') && value.endsWith('}'))) {
                    value = JSON.parse(value);
                }
            }

            result[prop] = value;
        }

        return result;
    }

    serialize() {
        const result = {};

        for (const prop in this) {
            if (!this.hasOwnProperty(prop)) continue;

            let value = this[prop];

            // Serialize arrays to CSV so we can store them in the DB
            if (_.isObjectLike(value)) value = JSON.stringify(value);

            result[prop] = value;
        }

        this.lastUpdated = this.getTimestamp();

        return result;
    }

    update(data = {}) {
        for (const prop in data) {
            this[prop] = data[prop];
        }

        this.lastUpdated = this.getTimestamp();
    }

    getTimestamp() {
        return moment().utc().format();
    }
}

export default UserPreferences;
